import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "listing-header" }
const _hoisted_2 = { class: "listing-header__title section-title" }
const _hoisted_3 = { class: "listing-header__btn" }
const _hoisted_4 = {
  key: 1,
  class: "listing-header__link"
}
const _hoisted_5 = { class: "listing-header__title section-title" }
const _hoisted_6 = {
  key: 2,
  class: "listing-header__actions"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ListingBlockHeader',
  props: {
    to: {},
    title: {},
    viewAllText: {},
    isEmpty: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.to && !__props.isEmpty)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: __props.to,
          class: "listing-header__link listing-header__link--link"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(__props.viewAllText || 'View all'), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.title), 1)
        ])),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})